import api from './utils/api';

class MediaUploadsService {
  async listMedias(id, type = null, page = 1, limit = 6) {
    const params = new URLSearchParams();

    if (type) params.append('type', type);
    params.append('page', page.toString());
    params.append('limit', limit.toString());

    const queryString = params.toString();
    const { data } = await api.get(
      `/model-uploads/medias/${id}?${queryString}`
    );

    return {
      urls: data.urls,
      pagination: data.pagination,
    };
  }

  async listAllMedias(id) {
    const { data } = await api.get(`/model-uploads/allmedias/${id}`);

    return data;
  }

  async getPresignedMedia(file) {
    const { data } = await api.post('/model-uploads/medias', {
      filename: file.name,
      type: file.type,
      size: file.size,
    });

    return {
      url: data.url,
      key: data.key,
    };
  }

  async updatePresignedMedia(url) {
    const result = await api.post('/model-uploads/medias/complete', { url });

    return result.data;
  }

  async deleteMedias(id) {
    const result = await api.delete(`/model-uploads/medias/${id}`);

    return result.data;
  }

  async listVerification(id) {
    const result = await api.get(`/model-uploads/verification/${id}`);

    return result.data;
  }

  async findById(mediaId) {
    const result = await api.get(`/model-uploads/byidmedias/${mediaId}`);

    return result.data;
  }

  async getPresignedVerification(file, label) {
    const { data } = await api.post('/model-uploads/verification', {
      filename: file.name,
      type: file.type,
      size: file.size,
      label,
    });

    return data.url;
  }

  async toggleLike(mediaId) {
    const result = await api.post('/model-uploads/medias/like', { mediaId });

    return result.data;
  }
}

export default new MediaUploadsService();
